<template>
  <div class="add-visit-container">
    <el-card class="box-card">
      <div slot="header" class="flex justify-between">
        <span>{{ $t('addVisit.title') }}</span>
      </div>
      <el-form ref="form" :model="addVisitInfo" :rules="rules" label-width="120px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$t('addVisit.vName')" prop="vName">
              <el-input
                v-model="addVisitInfo.vName"
                :placeholder="$t('addVisit.vNamePlaceholder')"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('addVisit.visitGender')" prop="visitGender">
              <el-select
                v-model="addVisitInfo.visitGender"
                :placeholder="$t('addVisit.genderPlaceholder')"
                style="width:100%"
              >
                <el-option :label="$t('addVisit.genderMale')" value="0"></el-option>
                <el-option :label="$t('addVisit.genderFemale')" value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$t('addVisit.phoneNumber')" prop="phoneNumber">
              <el-input
                v-model="addVisitInfo.phoneNumber"
                :placeholder="$t('addVisit.phoneNumberPlaceholder')"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('addVisit.carNum')" prop="carNum">
              <el-input
                v-model="addVisitInfo.carNum"
                :placeholder="$t('addVisit.carNumPlaceholder')"
              />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item :label="$t('addVisit.room')" class="text-left">
              <el-input
                v-model="addVisitInfo.roomName"
                style="width: 80%"
                :placeholder="$t('addVisit.roomPlaceholder')"
              />
              <el-button type="primary" @click="selectVisitRoom" style="margin-left:10px">
                {{ $t('addVisit.selectRoom') }}
              </el-button>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$t('addVisit.visitTime')" prop="visitTime">
              <el-date-picker
                v-model="addVisitInfo.visitTime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                :placeholder="$t('addVisit.visitTimePlaceholder')"
                style="width:100%"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('addVisit.departureTime')">
              <el-date-picker
                v-model="addVisitInfo.departureTime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                :placeholder="$t('addVisit.departureTimePlaceholder')"
                style="width:100%"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$t('addVisit.entourage')">
              <el-input-number
                v-model="addVisitInfo.entourage"
                :min="0"
                :max="99"
                style="width:100%"
              ></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item :label="$t('addVisit.visitCase')">
              <el-input
                type="textarea"
                :rows="3"
                v-model="addVisitInfo.visitCase"
                :placeholder="$t('addVisit.visitCasePlaceholder')"
              />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="24" style="text-align:right">
            <el-button @click="goBack">{{ $t('addVisit.back') }}</el-button>
            <el-button type="primary" :loading="submitting" @click="doSaveVisit">
              {{ $t('addVisit.register') }}
            </el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <room-tree ref="roomTree" @selectRoom="selectRoom" />
  </div>
</template>

<script>
import { saveVisit } from '@/api/oa/addVisitApi'
import { getCommunityId } from '@/api/community/communityApi'
import roomTree from '@/components/room/roomTree'

export default {
  name: 'AddVisitList',
  data() {
    return {
      submitting: false,
      addVisitInfo: {
        vName: '',
        visitGender: '',
        phoneNumber: '',
        visitTime: '',
        departureTime: '',
        roomId: '',
        roomName: '',
        ownerId: '',
        ownerName: '',
        carNum: '',
        entourage: 0,
        visitCase: '',
        communityId: ''
      },
      rules: {
        vName: [
          { required: true, message: this.$t('addVisit.vNameRequired'), trigger: 'blur' }
        ],
        visitGender: [
          { required: true, message: this.$t('addVisit.genderRequired'), trigger: 'change' }
        ],
        phoneNumber: [
          { required: true, message: this.$t('addVisit.phoneNumberRequired'), trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: this.$t('addVisit.phoneNumberFormat'), trigger: 'blur' }
        ],
        visitTime: [
          { required: true, message: this.$t('addVisit.visitTimeRequired'), trigger: 'change' }
        ]
      }
    }
  },
  components: { roomTree },
  created() {
    this.communityId = getCommunityId()
  },
  methods: {
    selectVisitRoom() {
      this.$refs.roomTree.open()
    },
    selectRoom(room) {
      this.addVisitInfo.roomId = room.roomId
      this.addVisitInfo.roomName = room.roomName
      this.addVisitInfo.ownerId = room.ownerId || ''
      this.addVisitInfo.ownerName = room.ownerName || ''
    },
    async doSaveVisit() {
      try {
        await this.$refs.form.validate()
      } catch (e) {
        return
      }

      this.submitting = true
      try {
        const data = {
          ...this.addVisitInfo,
          communityId: this.communityId
        }
        if (!data.entourage) {
          data.entourage = '0'
        }
        await saveVisit(data)
        this.$message.success(this.$t('common.operationSuccess'))
        this.goBack()
      } catch (error) {
        this.$message.error(error.message || this.$t('addVisit.saveError'))
      } finally {
        this.submitting = false
      }
    },
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
.add-visit-container {
  padding: 20px;
}

.box-card {
  margin-bottom: 20px;
}
</style>
